<div class="hbox">
  <div class="flex-box">
    <div class="flex-heading">
      <div class="col-xs-12 list-header">
        <ul class="breadcrumb">
          <li>{{productCollection['objectId'] ? productCollection['name'] : 'New'}}</li>
          <li>{{productCollection['objectId'] ? 'Edit' : 'New'}}</li>
        </ul>
      </div>
    </div>
    <div class="flex-content">
      <form class="p-4" #productCollectionForm="ngForm" (submit)="saveProductCollection()">
        <div class="col-xs-12">
          <div class="col-xs-6 p-1">
            <label class="col-xs-12 mt-0 ml-0">Name</label>
            <div class="col-xs-12">
              <input class="col-xs-12" class="custom-select-ticket" [(ngModel)]="productCollection['name']" name="name" required="required" placeholder="Name"/>
            </div>
          </div>
          <div class="col-xs-6 p-1">
            <label class="col-xs-12 mt-0 ml-0">Priority</label>
            <div class="col-xs-12">
              <input class="form-control" class="custom-select-ticket" [(ngModel)]="productCollection['priority']" name="priority" placeholder="Priority" type="number" min="0"/>
            </div>
          </div>
        </div>
        <div class="col-xs-12">
          <div class="col-xs-6 p-1">
            <label class="col-xs-12">Title Language string</label>
            <div class="col-xs-12">
              <span>{{title}}</span>
              <span class="fa fa-pencil-square-o pointer mx-2" (click)="editLanguageString('titleLanguageString')"></span>
            </div>
          </div>
          <div class="col-xs-6 p-1">
            <label class="col-xs-12 ml-0">Description</label>
            <div class="col-xs-12">
              <span>{{description}}</span>
              <span class="fa fa-pencil-square-o pointer mx-2" (click)="editLanguageString('descriptionLanguageString')"></span>
            </div>
          </div>
        </div>
        <div class="col-xs-12">
          <div class="col-xs-6">
            <label class="col-xs-12 p-0">Is Active</label>
            <label class="i-switch i-switch-sm bg-success">
              <input class="form-control ng-pristine ng-valid ng-touched" type="checkbox" [(ngModel)]="productCollection['isActive']" name="isActive"/><i></i>
            </label>
          </div>
          <div class="col-xs-6 p-1">
            <label class="col-xs-12">Product Image Type</label>
            <div class="col-xs-12">
              <select class="form-control custom-select-ticket" [(ngModel)]="productCollection['productImageType']" name="productImageType" required="required">
                <option value="SLIDER_IMAGE">Slider Image</option>
                <option value="PRODUCT_IMAGE">Product Image</option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-xs-12">
          <div class="col-xs-6">
            <label class="col-xs-12 p-0">Image URL</label>
            <div *ngIf="productCollection['imageUrl']" class="col-xs-12 mb-2">
              <img [src]="productCollection['imageUrl']" width="100" height="100">
            </div>
            <div class="col-xs-12 p-0">
              <input type="text" class="form-control custom-select-ticket" placeholder="Image URL..." matInput="matInput" name="imageUrl" autocomplete="off" [(ngModel)]="productCollection['imageUrl']"/>
            </div>
          </div>
          <div class="col-xs-6">
            <label class="col-xs-12 p-0">Display Type</label>
            <div class="col-xs-12 p-0">
              <select class="form-control custom-select-ticket" [(ngModel)]="productCollection['displayType']" name="displayType" required="required">
                <option *ngFor="let option of displayTypeOptions" [value]="option.value">{{option.display}}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-xs-12">
          <label class="col-xs-12">Products</label>
          <div class="col-xs-12 mb-4">
            <input type="text" class="form-control custom-select-ticket" placeholder="Type Product Name..." matInput="matInput" name="add_product" autocomplete="off" [formControl]="autoCompleteProductController" [matAutocomplete]="productAuto"/>
            <mat-autocomplete class="search-bar-xs" #productAuto="matAutocomplete">
              <mat-option *ngFor="let option of productOptions | async" [value]="option.name" (onSelectionChange)="autoCompleteOnProductSelect(option)">{{option.name}}</mat-option>
            </mat-autocomplete>
          </div>
          <div class="col-xs-12">
            <div class="col-xs-12 mb-2 p-0" *ngIf="products && products.length > 0">
              <div class="flex mb-2" *ngFor="let product of products; let i = index">
                <a class="inline product-label night" routerLink="/products/catalog/{{product.id || product.objectId || product.get?.('objectId')}}">
                  {{product.get ? product._displayTitle : product.displayTitle || 'Loading...'}}
                </a>
                <i class="fa fa-trash-o pointer ml-2" (click)="removeProduct(i)"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-6 mt-4 flex justifyFE pull-right">
          <button type="submit" class="btn-primary" [disabled]="!productCollectionForm.valid">{{ productCollection['objectId'] ? 'Update' : 'Create' }}</button>
        </div>
      </form>
    </div>
  </div>
</div>

